import { render } from "./EditLab.vue?vue&type=template&id=d63db55a&scoped=true"
import script from "./EditLab.vue?vue&type=script&lang=js"
export * from "./EditLab.vue?vue&type=script&lang=js"

import "./EditLab.vue?vue&type=style&index=0&id=d63db55a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63db55a"]])

export default __exports__